module.exports = __webpack_public_path__ + "static/media/university-of-lincoln.30b1c49b.png";